let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cjbdQ")).then(() => parcelRequire('aKTrI'));